export const GiftProcessStateEnum = Object.freeze({
    Pending: "Pending",
    Ordered: "Ordered",
    VoucherIssued: "Voucher Issued",
    Shipped: "Shipped"
});

export const GiftProcessStateValues = Object.values(GiftProcessStateEnum);
